module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_haba_enchilada.9dc568fb.pdf";